export enum EEnvironment {
  PRODUCTION = 'production',
  STAGING = 'staging',
  QA = 'qa',
}

export type TEnvironmentalVariables = {
  // the REACT_APP_ENVIRONMENT variable doesn't exist on locally run dev server
  REACT_APP_ENVIRONMENT?: EEnvironment;
};
